<div class="progress-stepper-item-wrapper d-flex flex-column mb-15 vo-body-regular-14">
  <a
    *ngIf="stepTitle"
    [innerHtml]="stepTitle | localizeLabel"
    class="step-title lh-28"
    (click)="scrollToSection(stepTitle)"
  ></a>

  <span
    class="step-status completed text-green-color vo-boi-status-completed lh-16"
    *ngIf="status?.IsComplete && !IsPending"
    [ngClass]="{ 'step-has-errors': status.HasBusinessValidationErrors || status.HasFullValidationErrors }"
    [innerHtml]="referenceDataLabels.CompleteId | localizeLabel"
  >
  </span>

  <span
    class="step-status in-completed text-orange-color vo-boi-status-in-completed lh-16"
    *ngIf="!status?.IsComplete && !IsPending"
    [ngClass]="{ 'step-has-errors': hasSubmitValidationError }"
    [innerHtml]="referenceDataLabels.IncompleteId | localizeLabel"
  >
  </span>

  <span
    class="step-status pending vo-boi-status-pending lh-16"
    *ngIf="IsPending"
    [ngClass]="{ 'step-has-errors': hasSubmitValidationError }"
    [innerHtml]="referenceDataLabels.PendingId | localizeLabel"
  >
  </span>
</div>
